const LEADS_STORAGE_KEY = 'leads_storage';

function safeLocalStorage(window) {
    try {
        return window?.localStorage || null;
    } catch (error) {
        if (error?.name !== 'SecurityError') {
            // eslint-disable-next-line no-console
            console.error(error);
        }
        // В инкогнито или под ITP может падать с SecurityError — возвращаем null.
        return null;
    }
}

export function readPersistedValues(window) {
    const storage = safeLocalStorage(window);
    if (storage) {
        try {
            const storedValue = storage.getItem(LEADS_STORAGE_KEY);
            if (storedValue) {
                const parsed = JSON.parse(storedValue);
                if (parsed && typeof parsed === 'object') {
                    return {
                        lfid: typeof parsed.lfid === 'string' ? parsed.lfid : null,
                        cfid: typeof parsed.cfid === 'string' ? parsed.cfid : null,
                        rd: typeof parsed.rd === 'string' ? parsed.rd : null,
                    };
                }
            }
        } catch (error) {
            if (error?.name !== 'SecurityError') {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        }
    }
    return window?.__leadsFpState__?.persistedValues || null;
}

export function storePersistedValues(window, values) {
    if (!window.__leadsFpState__) {
        window.__leadsFpState__ = {};
    }

    if (!values || (!values.lfid && !values.cfid && !values.rd)) {
        const storage = safeLocalStorage(window);
        if (storage) {
            try {
                storage.removeItem(LEADS_STORAGE_KEY);
            } catch (error) {
                if (error?.name !== 'SecurityError') {
                    // eslint-disable-next-line no-console
                    console.error(error);
                }
            }
        }
        delete window.__leadsFpState__.persistedValues;
        return;
    }

    const payload = {
        lfid: values.lfid ?? null,
        cfid: values.cfid ?? null,
        rd: values.rd ?? null,
    };

    const storage = safeLocalStorage(window);
    if (storage) {
        try {
            storage.setItem(LEADS_STORAGE_KEY, JSON.stringify(payload));
        } catch (error) {
            if (error?.name !== 'SecurityError') {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        }
    }
    window.__leadsFpState__.persistedValues = payload;
}

export function mergePersistedValues(current, next) {
    const merged = {
        lfid: next?.lfid ?? current?.lfid ?? null,
        cfid: next?.cfid ?? current?.cfid ?? null,
        rd: next?.rd ?? current?.rd ?? null,
    };

    if (!merged.lfid && !merged.cfid && !merged.rd) {
        return null;
    }

    return merged;
}
